import { Fragment, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from './header/draft/Icon';
import { OpenAppQrPanel } from './common/OpenAppQrPanel';
import { isHomeNavSection, NAV_ITEMS } from '../constants/navItems';
import { HomeScenarioSubNav } from './nav/HomeScenarioSubNav';
import './nav/draft-sidebar.css';

const Navigate = ({ onClickMenu, compact = false }: { onClickMenu?: () => void; compact?: boolean }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [showQR, setShowQR] = useState(false);
  const isCompact = compact || location.pathname.includes('/app/player/');

  const onClickOpenQR = () => setShowQR(true);
  const onClickCloseQR = () => setShowQR(false);

  return (
    <nav className={`soundpill-draft-sidebar${isCompact ? ' soundpill-draft-sidebar--compact' : ''}`}>
      <div className="soundpill-draft-sidebar__shell">
        <div className="soundpill-draft-sidebar__nav-list">
          {NAV_ITEMS.map((item) => (
            <Fragment key={item.to}>
              {item.dividerBefore ? <hr className="soundpill-draft-sidebar__divider" aria-hidden /> : null}
              <NavItem
                icon={item.icon}
                name={t(item.labelKey)}
                path={item.to}
                end={item.end}
                matchPrefix={item.matchPrefix}
                homeSectionActive={item.hasHomeSubNav ? isHomeNavSection(location.pathname) : undefined}
                compact={isCompact}
              />
              {item.hasHomeSubNav && !isCompact ? <HomeScenarioSubNav variant="sidebar" /> : null}
            </Fragment>
          ))}
        </div>

        {!isCompact && (
        <div className="soundpill-draft-sidebar__footer">
          <button type="button" onClick={onClickOpenQR} className="soundpill-draft-sidebar__use-app-btn">
            {t('navigator.useApp')}
          </button>

          <div className="soundpill-draft-sidebar__legal">
            <Link onClick={onClickMenu} to="/app/terms-of-use">
              {t('navigator.useTerm')}
            </Link>
            <Link onClick={onClickMenu} to="/app/privacy-policy">
              {t('navigator.privatePolicy')}
            </Link>
          </div>
        </div>
        )}

        <div
          className={`soundpill-draft-sidebar__qr-panel ${
            showQR ? '' : 'soundpill-draft-sidebar__qr-panel--hidden'
          }`}
        >
          <OpenAppQrPanel onClose={onClickCloseQR} variant="sidebar" showConfirmButton={false} />
        </div>
      </div>
    </nav>
  );
};

function NavItem({
  icon,
  name,
  path,
  end,
  matchPrefix,
  homeSectionActive,
  compact,
}: {
  icon: string;
  name: string;
  path: string;
  end?: boolean;
  matchPrefix?: string;
  homeSectionActive?: boolean;
  compact?: boolean;
}) {
  const location = useLocation();

  return (
    <NavLink
      to={path}
      end={end}
      title={compact ? name : undefined}
      className={({ isActive, isPending }) => {
        const active =
          homeSectionActive === true
            ? true
            : matchPrefix
              ? location.pathname.startsWith(matchPrefix)
              : isActive;
        const base = compact ? 'soundpill-draft-nav-item soundpill-draft-nav-item--compact' : 'soundpill-draft-nav-item';
        return `${base} ${isPending ? '' : active ? 'soundpill-draft-nav-item--active' : ''}`;
      }}
    >
      {({ isActive }) => {
        const active =
          homeSectionActive === true
            ? true
            : matchPrefix
              ? location.pathname.startsWith(matchPrefix)
              : isActive;
        return (
          <>
            <Icon name={icon} filled={active} className="soundpill-draft-nav-item__symbol" />
            {!compact && <span className="soundpill-draft-nav-item__label">{name}</span>}
          </>
        );
      }}
    </NavLink>
  );
}

export default Navigate;
